"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var typeChecks_1 = require("./typeChecks");
var date_1 = require("./date");
function defaultGetKeyFn(item) {
    return item ? item.toString() : '';
}
function filterOutEmpty(collection, getValueFn) {
    if (!getValueFn) {
        getValueFn = function (item) { return item; };
    }
    return collection.filter(function (item) { return !typeChecks_1.isNullOrEmpty(getValueFn(item)); });
}
exports.filterOutEmpty = filterOutEmpty;
function findWithMatchingProperties(collection, matchingProperties) {
    return (collection || []).find(function (item) {
        return Object.keys(matchingProperties).every(function (key) { return item[key] === matchingProperties[key]; });
    });
}
exports.findWithMatchingProperties = findWithMatchingProperties;
function filterWithMatchingProperties(collection, matchingProperties) {
    return (collection || []).filter(function (item) {
        return Object.keys(matchingProperties).every(function (key) { return item[key] === matchingProperties[key]; });
    });
}
exports.filterWithMatchingProperties = filterWithMatchingProperties;
function pivotCollection(collection, getKeyFn, getValueFn) {
    if (getValueFn === void 0) { getValueFn = (function (value) { return value; }); }
    return (collection || []).reduce(function (acc, element) {
        var key = getKeyFn(element);
        acc[key] = getValueFn(element);
        return acc;
    }, {});
}
exports.pivotCollection = pivotCollection;
function sortBy(collection, getValueFn, order, culture) {
    if (order === void 0) { order = 'ASC'; }
    return (collection || []).sort(function (a, b) {
        var aValue = getValueFn(a);
        var bValue = getValueFn(b);
        var response;
        if (typeof aValue === 'number' && typeof bValue === 'number') {
            response = aValue > bValue ? 1 : -1;
        }
        else {
            response = aValue.toString().localeCompare(bValue.toString(), culture);
        }
        if (order === 'DESC') {
            response = response * -1;
        }
        return response;
    });
}
exports.sortBy = sortBy;
var SortType;
(function (SortType) {
    SortType["months3char"] = "months3char";
    SortType["monthsFull"] = "monthsFull";
    SortType["weekdays2char"] = "weekdays2char";
    SortType["weekdays3char"] = "weekdays3char";
    SortType["weekdaysFull"] = "weekdaysFull";
    SortType["meridiemUppercase"] = "meridiemUppercase";
    SortType["meridiemLowercase"] = "meridiemLowercase";
    SortType["meridiemFull"] = "meridiemFull";
    SortType["custom"] = "custom";
    SortType["default"] = "default";
})(SortType = exports.SortType || (exports.SortType = {}));
;
;
function sortByType(collection, getValueFn, options) {
    var _a = options.sortType, sortType = _a === void 0 ? 'default' : _a, _b = options.order, order = _b === void 0 ? 'ASC' : _b, _c = options.ignoreCase, ignoreCase = _c === void 0 ? false : _c, culture = options.culture, translate = options.translate, _d = options.customComparisonList, customComparisonList = _d === void 0 ? [] : _d;
    if (sortType === 'default') {
        return sortBy(collection, getValueFn, order, culture);
    }
    var comparisonList = sortType === 'custom' ? customComparisonList : getComparisonList(sortType);
    if (translate) {
        date_1.translateArray(translate, comparisonList);
    }
    if (ignoreCase) {
        comparisonList = comparisonList.map(function (item) { return item = item.toLocaleLowerCase(culture); });
    }
    // Any values in "collection" that are not part of the known value list will be returned at the end of the response list
    var validCollection = [];
    var invalidCollection = [];
    collection.forEach(function (item) {
        var value = getValueFn(item);
        if (ignoreCase) {
            value = value.toLocaleLowerCase(culture);
        }
        if (comparisonList.includes(value)) {
            validCollection.push(item);
        }
        else {
            invalidCollection.push(item);
        }
    });
    var getKnownValueFn = function (item) {
        var value = getValueFn(item);
        if (ignoreCase) {
            value = value.toLocaleLowerCase(culture);
        }
        return comparisonList.indexOf(value);
    };
    var sortedValidCollection = sortBy(validCollection, getKnownValueFn, order, culture);
    return __spreadArrays(sortedValidCollection, invalidCollection);
}
exports.sortByType = sortByType;
function getComparisonList(knownType) {
    switch (knownType) {
        case SortType.months3char: return date_1.months3char;
        case SortType.monthsFull: return date_1.monthsFull;
        case SortType.weekdays2char: return date_1.weekdays2char;
        case SortType.weekdays3char: return date_1.weekdays3char;
        case SortType.weekdaysFull: return date_1.weekdaysFull;
        case SortType.meridiemUppercase: return date_1.meridiemUppercase;
        case SortType.meridiemLowercase: return date_1.meridiemLowercase;
        case SortType.meridiemFull: return date_1.meridiemFull;
        default: return [];
    }
}
function sortByDate(collection, getStringDateFn, order) {
    if (order === void 0) { order = 'ASC'; }
    if (collection) {
        var sorted = collection.map(function (item) {
            var stringDateValue = getStringDateFn(item);
            return __assign(__assign({}, item), { _sortDate: stringDateValue ? new Date(stringDateValue).getTime() : 0 });
        });
        sorted = sorted.sort(function (a, b) {
            var result = a._sortDate - b._sortDate;
            if (order === 'DESC') {
                result = result * -1;
            }
            return result;
        });
        return sorted.map(function (_a) {
            var _sortDate = _a._sortDate, props = __rest(_a, ["_sortDate"]);
            return props;
        });
    }
    return collection;
}
exports.sortByDate = sortByDate;
function mapToObject(collection, getKeyFn) {
    var mappedObject = {};
    for (var _i = 0, collection_1 = collection; _i < collection_1.length; _i++) {
        var item = collection_1[_i];
        var itemKey = getKeyFn(item);
        mappedObject[itemKey] = item;
    }
    return mappedObject;
}
function union(first, second, getKeyFn) {
    if (typeChecks_1.isNullOrUndefined(first) || typeChecks_1.isNullOrUndefined(second)) {
        return null;
    }
    if (!getKeyFn) {
        getKeyFn = defaultGetKeyFn;
    }
    var mappedObject = mapToObject(__spreadArrays(first, second), getKeyFn);
    var result = Object.keys(mappedObject).map(function (e) {
        return mappedObject[e];
    });
    return result;
}
exports.union = union;
function intersect(first, second, getKeyFn) {
    if (typeChecks_1.isNullOrUndefined(first) || typeChecks_1.isNullOrUndefined(second)) {
        return null;
    }
    if (!getKeyFn) {
        getKeyFn = defaultGetKeyFn;
    }
    var mappedObject = mapToObject(second, getKeyFn);
    var result = first.filter(function (item) {
        var itemKey = getKeyFn(item);
        return mappedObject[itemKey];
    });
    return result;
}
exports.intersect = intersect;
function except(first, second, getKeyFn) {
    if (typeChecks_1.isNullOrUndefined(first) || typeChecks_1.isNullOrUndefined(second)) {
        return null;
    }
    if (!getKeyFn) {
        getKeyFn = defaultGetKeyFn;
    }
    var mappedObject = mapToObject(second, getKeyFn);
    var result = first.filter(function (item) {
        var itemKey = getKeyFn(item);
        return !mappedObject[itemKey];
    });
    return result;
}
exports.except = except;
function groupBy(collection, getValueFn) {
    return (collection || []).reduce(function (acc, obj) {
        var value = getValueFn(obj);
        acc[value] = (acc[value] || []).concat(obj);
        return acc;
    }, {});
}
exports.groupBy = groupBy;
function split(collection, itemsPerRow, isBreakpoint) {
    if (itemsPerRow === void 0) { itemsPerRow = 1; }
    if (typeChecks_1.isNullOrUndefined(collection)) {
        return [];
    }
    if (!isBreakpoint) {
        isBreakpoint = function (element) {
            return false;
        };
    }
    if (typeChecks_1.isNullOrUndefined(itemsPerRow) || itemsPerRow < 1) {
        itemsPerRow = 1;
    }
    var rows = [];
    var currentRow = [];
    var count = 0;
    for (var _i = 0, collection_2 = collection; _i < collection_2.length; _i++) {
        var element = collection_2[_i];
        if (count === itemsPerRow || isBreakpoint(element)) {
            rows.push(currentRow);
            currentRow = [];
            count = 0;
        }
        currentRow.push(element);
        count++;
    }
    rows.push(currentRow);
    return rows;
}
exports.split = split;
function unique(collection, getValueFn) {
    if (typeChecks_1.isNullOrUndefined(collection)) {
        return [];
    }
    // get keys to determine unique collection
    var keys = collection.map(function (obj) { return getValueFn(obj); });
    // filter collection to bring back a unique list based on the keys
    var uniqueCollection = collection.filter(function (obj, pos, arr) {
        // indexOf returns the index of the first occurrence, using this logic,
        // we can filter out the duplicates that don't match the with the first occurrence therefore giving us a unique list.
        var value = getValueFn(obj);
        return keys.indexOf(value) === pos;
    });
    return uniqueCollection;
}
exports.unique = unique;
/**
 * Used to flatten multidimensional arrays. Not needed with ES2020 (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/flat)
 * @param arr
 * @param depth pass `infinity` to flatten all levels of arrays
 * @returns array
 */
function flatDeep(arr, depth) {
    if (depth === void 0) { depth = 1; }
    if (arr) {
        return depth > 0 ?
            arr.reduce(function (acc, val) { return acc.concat(Array.isArray(val) ?
                flatDeep(val, depth - 1) :
                val); }, [])
            : arr.slice();
    }
    return null;
}
exports.flatDeep = flatDeep;
//# sourceMappingURL=collection.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@kurtosys/ksys-app-template/dist/utils/collection.js
// module id = 48
// module chunks = 1